import { Component, OnInit, HostListener } from '@angular/core';
import { ArticleService } from '../services/article.service'
import { from } from 'rxjs';
import { UserService } from '../services/user.service';
import { AssignmentService } from '../services/assignment.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isCollapsed = false;
  loading = false;
  article:any=[];
  tasks:any=[];
  notscrolly = true;
  notEmptyPost = true;
  perPage = 10;
  page = 1;
  total:string;
  getFullYear: number = new Date().getFullYear();
  avatar:any;
  isAvatar:boolean = false;
  profileData:any = [];
  announcement:any=[];
  constructor(
    private articleService: ArticleService,
    private userService:UserService,
    private assignmentService:AssignmentService
  ) { }

  ngOnInit() {
    this.getPost();
    this.getAnnouncement();
    this.profile();
    this.getTasks();
  }

  //load the Initial 10 posts
  getPost() {
    this.loading = true; 
    this.articleService.getAll(10, this.page).subscribe((res:any)=>{
      this.loading = false;
      this.article = res.data.docs;
    });
  }

  getAnnouncement(){
    this.articleService.getAnnouncement(10, this.page).subscribe((res:any)=>{
      this.announcement = res.data.docs;
    });
  }

  profile(){
    this.userService.getProfile().subscribe((res:any)=>{
      this.avatar = environment.apiUrl + '/static/' + res.data.employee.avatar;
      this.profileData = res.data.employee;
      if(this.avatar == "https://apihr.ttu.edu.vn/v1/static/"){
        console.log("chưa có avatar")
        this.isAvatar = false;
      }else{
        this.isAvatar = true;
      }
      // console.log('this.avatar', this.avatar)
    });
  }

  getTasks(): void {
    this.assignmentService.getAssignmentContent(4, this.page).subscribe((res:any)=>{
      this.loading = false;
      this.tasks = res.data.data;
      // console.log('tasks',this.tasks);
    });
  }

}